module.exports = __webpack_public_path__ + "static/media/backWave9.eef6d103.svg";